import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { startCase } from 'lodash';
import { dollars } from 'utils/money';
import { date } from 'utils/date';
import RepaymentForm from 'components/Loans/RepaymentForm';

const styleSheet = (theme) => ({
  overdue: {
    color: theme.palette.error.main
  },
  highlighted: {
    border: "2px solid #00ff00"
  },
});

class Loan extends React.Component {
  renderLoan = () => {
    const { loan } = this.props;

    return (
      <div>
        <Typography variant="title" gutterBottom>
          Loan details
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Loan number</TableCell>
              <TableCell>Principal</TableCell>
              <TableCell>Interest rate</TableCell>
              <TableCell>Application fee</TableCell>
              <TableCell>Term length</TableCell>
              <TableCell>Drawdown date</TableCell>
              <TableCell>Repayment frequency</TableCell>
              <TableCell>Confirmed at</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {loan.loanNumber}
              </TableCell>
              <TableCell>
                {dollars(loan.principal)}
              </TableCell>
              <TableCell>
                {`${loan.interestRate}%`}
              </TableCell>
              <TableCell>
                {dollars(loan.establishmentFee)}
              </TableCell>
              <TableCell>
                {`${loan.termLength} ${loan.termUnit}`}
              </TableCell>
              <TableCell>
                {date(loan.drawdownDate)}
              </TableCell>
              <TableCell>
                {loan.repaymentFrequency}
              </TableCell>
              <TableCell>
                {date(loan.confirmedAt)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  renderSchedule = (schedule) => {
    const classes = this.props.classes;
    const highlighted = this.props.highlightScheduleID == schedule.id

    return (
      <TableRow key={schedule.id} className={highlighted && classes.highlighted}>
        <TableCell>
          {date(schedule.repaymentDatetime)}
        </TableCell>
        <TableCell>
          {schedule.days}
        </TableCell>
        <TableCell>
          {dollars(schedule.principal)}
        </TableCell>
        <TableCell>
          {dollars(schedule.interest)}
        </TableCell>
        <TableCell>
          {dollars(schedule.establishmentFee)}
        </TableCell>
        <TableCell>
          <strong>{dollars(schedule.totalPayable)}</strong>
        </TableCell>
        <TableCell className={schedule.statusToDate == "overdue" && classes.overdue}>
          {
            <RepaymentForm
              buttonStyles={classes.headerButton}
              buttonLabel={startCase(schedule.statusToDate)}
              mode='update'
              repayment={schedule}
              form={`updateSchedule{schedule.id}`}
            />
          }
        </TableCell>
      </TableRow>
    );
  }

  renderSchedules = () => {
    const { loanSchedules } = this.props.loan;
    return (
      <div>
        <Typography variant="title" gutterBottom>
          Schedule
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Repayment date</TableCell>
              <TableCell>Days</TableCell>
              <TableCell>Principal</TableCell>
              <TableCell>Interest</TableCell>
              <TableCell>Establishment</TableCell>
              <TableCell>Total payable</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loanSchedules.map(schedule => this.renderSchedule(schedule))}
          </TableBody>
        </Table>
      </div>
    );
  }

  render = () => {
    return (
      <div>
        {this.renderLoan()}
        <br />
        {this.renderSchedules()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const reduxed = connect(mapStateToProps)(Loan);
export default withStyles(styleSheet)(reduxed);



// WEBPACK FOOTER //
// ./src/components/Loans/Loan.js